export enum WasteFluidTypes {
  NORMAL = 1, // 正常
  FIBRIN = 2, // フィブリン
  TURBIDITY = 3 // 混濁
}

export enum ExitsiteTypes {
  NORMAL = 1, // 通常
  REDNESS = 2, // 赤み
  PAIN = 3, // 痛み
  SWELL = 4, // 腫れ
  SCAB = 5, // かさぶた
  PUS = 6 // 膿
}

export enum SwellingTypes {
  NO_SWELLING = 0, // なし
  SWOLLEN = 1, // あり
  AGGRAVATION = 2 // 悪化
}

export const WasteFluidDict = {
  [WasteFluidTypes.NORMAL]: '正常',
  [WasteFluidTypes.FIBRIN]: 'フィブリン',
  [WasteFluidTypes.TURBIDITY]: '混濁'
}

export const ExitsiteDict = {
  [ExitsiteTypes.NORMAL]: '正常',
  [ExitsiteTypes.REDNESS]: '赤み',
  [ExitsiteTypes.PAIN]: '痛み',
  [ExitsiteTypes.SWELL]: '腫れ',
  [ExitsiteTypes.SCAB]: 'かさぶた',
  [ExitsiteTypes.PUS]: '膿'
}

export const SwellingDict = {
  [SwellingTypes.NO_SWELLING]: '無',
  [SwellingTypes.SWOLLEN]: '有',
  [SwellingTypes.AGGRAVATION]: '悪化'
}
